import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';

import logo from '../../../img/cc-logo-2022-color.svg';

const AboutModal = ({ isOpen = false, onClose }) => {
	return (
		<Modal
			isOpen={isOpen}
			contentLabel="About Care Convene Provider Portal"
			className="modal-dialog modal-sm"
			shouldCloseOnOverlayClick
			shouldCloseOnEsc
			onRequestClose={onClose}
		>
			<div className="modal-content">
				<div className="modal-header">
					<div className="clearfix">
						<div className="pull-right">
							<button className="btn btn-link" onClick={onClose}>
								<em className="fa fa-lg fa-times" />
							</button>
						</div>
						<h3 className="modal-title">
							About
						</h3>
					</div>
				</div>
				<div className="modal-body">
					<div className="mv">
						<img alt="CareConvene logo" src={logo} />
					</div>
					<h4 className="mt-xl text-center"><strong>CareConvene Provider Portal</strong></h4>
					<p className="text-center">PACKAGE_VERSION</p>
				</div>
			</div>
		</Modal>
	);
};

AboutModal.propTypes = {
	isOpen: PropTypes.bool,
	onClose: PropTypes.func.isRequired
};

export default AboutModal;
